var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 49,
    viewBox: "0 0 73 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1259_27133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7438 20.7711C64.9536 19.5343 63.9745 18.4349 62.8063 17.4729C58.7235 14.2514 54.3577 13.8293 50.7987 14.0931C48.8479 6.44256 43.8979 2.0761 36.5235 2C34.3933 2 32.3663 2.42946 30.4424 3.28836C28.5184 4.14729 26.852 5.2466 25.4435 6.58652C24.0348 7.92643 22.9182 9.60984 22.0937 11.6369C21.1653 14.2348 20.9381 15.6454 20.9084 18.3278C18.255 17.6572 14.6404 17.4874 12.4051 18.3793C9.72527 19.5475 7.83566 21.5401 6.73627 24.3573C6.04914 26.2469 5.84301 28.1022 6.11785 29.9231C6.3927 31.7439 7.13137 33.4103 8.33378 34.9219C9.53626 36.4336 11.0479 37.533 12.8688 38.2201C14.1399 38.7011 15.394 38.9416 16.6308 38.9416H53.6332C56.5879 38.9416 59.302 39.4049 61.7756 37.7215C67.7961 33.4743 68.9747 25.9921 65.7438 20.7708L65.7438 20.7711Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7438 20.7711C64.9536 19.5343 63.9745 18.4349 62.8063 17.4729C58.7235 14.2514 54.3577 13.8293 50.7987 14.0931C48.8479 6.44256 43.8979 2.0761 36.5235 2C34.3933 2 32.3663 2.42946 30.4424 3.28836C28.5184 4.14729 26.852 5.2466 25.4435 6.58652C24.0348 7.92643 22.9182 9.60984 22.0937 11.6369C21.1653 14.2348 20.9381 15.6454 20.9084 18.3278C18.255 17.6572 14.6404 17.4874 12.4051 18.3793C9.72527 19.5475 7.83566 21.5401 6.73627 24.3573C6.04914 26.2469 5.84301 28.1022 6.11785 29.9231C6.3927 31.7439 7.13137 33.4103 8.33378 34.9219C9.53626 36.4336 11.0479 37.533 12.8688 38.2201C14.1399 38.7011 15.394 38.9416 16.6308 38.9416H53.6332C56.5879 38.9416 59.302 39.4049 61.7756 37.7215C67.7961 33.4743 68.9747 25.9921 65.7438 20.7708L65.7438 20.7711Z",
    stroke: "#969696",
    strokeWidth: 2.54802
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1259_27133",
    x: 0.726044,
    y: 0.725586,
    width: 72.047,
    height: 47.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1259_27133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1259_27133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d86572e664965da86ffcd3543ea07229.svg";
export { ForwardRef as ReactComponent };